import { render, staticRenderFns } from "./demandOrder.vue?vue&type=template&id=c6180e7a&scoped=true"
import script from "./demandOrder.vue?vue&type=script&lang=js"
export * from "./demandOrder.vue?vue&type=script&lang=js"
import style0 from "./demandOrder.vue?vue&type=style&index=0&id=c6180e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6180e7a",
  null
  
)

export default component.exports